export default __webpack_public_path__ + "static/media/profile.fedd0bfc.svg";